<template>
  <object v-if="source" :data="source" class="user-icon" type="image/png">
    <img class="user-icon" src="@/assets/shapes/user-icon-placeholder.svg">
  </object>
  <img v-else class="user-icon" src="@/assets/shapes/user-icon-placeholder.svg">
</template>

<script>
  export default {
    name: 'user-icon',
    props: {
      source: {
        type: String,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .user-icon {
    height: 8em;
    width: 8em;
    object-fit: cover;
    border-radius: 99999px;
  }
</style>
